module.exports = __webpack_public_path__ + "static/img/02009A_1_V_20201118_LC.4b2a6f3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/02009A_1_V_20201118_LC.png
// module id = 9E8P
// module chunks = 0